class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// =================================================================
// Shared helper to keep desktop/mobile scroll lock in sync
// =================================================================
function shouldKeepScrollLocked() {
  return (
    document.querySelector('header-menu details[open]') ||
    document.querySelector('header-drawer details#Details-menu-drawer-container[open]') ||
    document.querySelector('.new-header-search-wrapper.active')
  );
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.overlay = document.querySelector('.custom-megamenu-overlay');

    // Attach overlay click listener only once
    if (this.overlay && !this.overlay.dataset.listenerAttached) {
      this.overlay.dataset.listenerAttached = 'true';
      this.overlay.addEventListener('click', () => {
        document.querySelectorAll('header-menu details[open]').forEach((details) => {
          details.removeAttribute('open');
          details.querySelector('summary').setAttribute('aria-expanded', false);
        });
        this.overlay.classList.remove('is-visible');
        if (!shouldKeepScrollLocked()) {
          document.body.classList.remove('overflow-hidden-megamenu');
        }
      });
    }
  }

  onToggle() {
    if (this.mainDetailsToggle.open) {
      document.body.classList.add('overflow-hidden-megamenu');
      if (this.overlay) {
        this.overlay.classList.add('is-visible');
      }
    } else if (!document.querySelector('header-menu details[open]')) {
      if (!shouldKeepScrollLocked()) {
        document.body.classList.remove('overflow-hidden-megamenu');
      }
      if (this.overlay) {
        this.overlay.classList.remove('is-visible');
      }
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== ''
    )
      return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);


// =================================================================
// MOBILE DRAWER SCROLL LOCK
// =================================================================
document.addEventListener('DOMContentLoaded', () => {
  const mobileDrawer = document.querySelector(
    'header-drawer details#Details-menu-drawer-container'
  );
  if (mobileDrawer) {
    mobileDrawer.addEventListener('toggle', () => {
      if (mobileDrawer.hasAttribute('open')) {
        document.body.classList.add('overflow-hidden-megamenu');
      } else if (!shouldKeepScrollLocked()) {
        document.body.classList.remove('overflow-hidden-megamenu');
      }
    });
  }
});